import React from "react";
import { motion } from "framer-motion";
import logo1Img from "../assets/PartnerLogo/comptia-logo.svg";
import Logo2Img from "../assets/PartnerLogo/lava.jpg";
import logo3Img from "../assets/PartnerLogo/Lorem.avif";
import logo4Img from "../assets/PartnerLogo/network.png";
import logo5Img from "../assets/PartnerLogo/parmpara.webp";
import logo6Img from "../assets/PartnerLogo/unik.jpg";

import GetStarted from "./GetStarted"; // ⬅️ Import the component

const logos = [logo1Img, Logo2Img, logo3Img, logo4Img, logo5Img, logo6Img];

const PartnerPage = () => {
  return (
    <>
      <div className="bg-white text-center p-10">
        <h2 className="text-4xl font-bold">
          <span className="text-orange-500">Strong Partnerships Build a</span>{" "}
          <span className="text-blue-900">Nadezhda Venture</span>
        </h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-4">
          We believe in the power of collaboration. Our partnerships with
          industry-leading companies ensure that we deliver top-tier solutions
          and services to our clients.
        </p>

        <div className="relative overflow-hidden mt-10">
          <motion.div
            className="flex gap-16 whitespace-nowrap animate-slide"
            initial={{ x: 0 }}
            animate={{ x: "-100%" }}
            transition={{
              repeat: Infinity,
              duration: 20,
              ease: "linear",
            }}
          >
            {[...logos, ...logos].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt="partner logo"
                className="h-16 w-auto object-contain"
              />
            ))}
          </motion.div>
        </div>
      </div>

    </>
  );
};

export default PartnerPage;
